import { jsx as _jsx } from "react/jsx-runtime";
import s from '../Popup.module.scss';
export const Arrow = ({ id, attributes }) => {
    return _jsx("div", Object.assign({ id: s.arrow, className: s.arrow, "data-popper-arrow": true }, attributes));
};
